"use client";

import React, { useState } from "react";
import { AccordionProps } from "@/src/components/ui/Accordion";

const AccordionList = ({ children }: { children: React.ReactNode }) => {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggleAccordion = (id: number) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <div className="w-full flex flex-col gap-4 md:gap-8">
      {React.Children.map(children, (child) => {
        if (React.isValidElement<AccordionProps>(child)) {
          return React.cloneElement(child, {
            isOpen: child.props.id === openId,
            toggle: toggleAccordion,
          });
        }
        return child;
      })}
    </div>
  );
};

export default AccordionList;
